import { useState } from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';

const CountField = ({ label, name, onChange, value = 0, minValue = 0 }) => {
  const theme = useTheme();
  const [count, setCount] = useState(value);

  const fireOnChange = (newCount) => {
    onChange({ target: { value: newCount, name: name } });
  };

  const handleSubtractClick = () => {
    if (count > minValue) {
      const newCount = count - 1;
      setCount(newCount);
      fireOnChange(newCount);
    }
  };

  const handleSumClick = () => {
    const newCount = count + 1;
    setCount(newCount);
    fireOnChange(newCount);
  };

  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="row"
      alignItems={'center'}
      justifyContent={'space-between'}
      backgroundColor={`${theme.palette.background.default}`}
      sx={{ borderRadius: '8px', minHeight: '45px' }}
      width="100%"
      flexGrow={1}
    >
      <Typography
        sx={{
          fontSize: `${theme.typography.body1.fontSize}`,
          fontWeight: `${theme.typography.body1.fontWeight}`,
          color: theme.palette.primary.main,
          paddingLeft: '1rem',
          flexGrow: 1,
        }}
      >
        {label}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems={'center'}>
        <Button
          sx={{
            backgroundColor: '#E0EDFF',
            minWidth: '36px',
            height: '36px',
            margin: '0 11px',
          }}
          onClick={handleSubtractClick}
        >
          <Typography
            sx={{
              fontSize: 24,
              color: `${theme.palette.primary.main}`,
            }}
          >
            -
          </Typography>
        </Button>
        {count}
        <Button
          sx={{
            backgroundColor: '#E0EDFF',
            minWidth: '36px',
            height: '36px',
            margin: '0 11px',
          }}
          onClick={handleSumClick}
        >
          <Typography
            sx={{
              fontSize: 24,
              color: `${theme.palette.primary.main}`,
            }}
          >
            +
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default CountField;
